module.exports = __webpack_public_path__ + "img/tools-referral-program.77b54cf9.png";